import Component from './instantwin_message_dialog.vue'
export default Component
